export default {
  data() {
    return {
      appbarHeight: 90
    }
  },
  computed: {
    urlPortail() {
      return process.env.VUE_APP_URL_PORTAIL
    }
  }
}